import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './auth-context';

/**
 * Route wrapper for account-scoped pages: keep a bare footprint while the
 * session resolves, then send guests (including direct deep-links) to the
 * About landing page rather than render account UI.
 */
export function RequireAuth() {
  const { user, loading } = useAuth();
  if (loading) return <main className="flex-1" aria-hidden />;
  if (!user) return <Navigate to="/about" replace />;
  return <Outlet />;
}
